import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Snackbar } from '@material-ui/core';
import { SnackbarContent } from '@material-ui/core';
import { green } from '@material-ui/core/colors';

interface Props {
  open: boolean;
  onClose: () => void
  massage: string
}

type LocalStyles = 'success';

const localStyles: StyleRulesCallback<LocalStyles> = () => ({
  success: {
    backgroundColor: green[600],
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class SaveSnackBar extends React.Component<PropsWithStyle, {}> {

  public render() {
    return (
      <Snackbar
        className={this.props.classes.success}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={this.props.onClose}
        open={this.props.open}
        autoHideDuration={3000}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
      >
        <SnackbarContent className={this.props.classes.success} message={this.props.massage}/>
      </Snackbar>
    );
  }

}

export default withStyles(localStyles)(SaveSnackBar);
